module.exports = __webpack_public_path__ + "static/media/2.0a9a54c6.png";